import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { lithuanianMistakes } from '../block5Components/EvaluationAcousticMistake';
import { evaluationRemainingMistakesConfig } from '../block5Components/EvaluationRemainingMistakes';
import { FormBlockTypes } from './DocumentPreviewSubjectData';
import { PreviewNestedData } from './PreviewNestedData';

type DocumentPreviewBock5Props = {
  data: FormBlockTypes;
  selectedSubject: string;
};

export const DocumentPreviewBlock5 = ({
  data,
  selectedSubject,
}: DocumentPreviewBock5Props) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      key: 'evaluation',
      evaluation: {},
    };
    if (data) {
      changedTableData.evaluation = (
        <PreviewNestedData
          fieldsData={data}
          fieldsConfig={{
            ...lithuanianMistakes,
            ...evaluationRemainingMistakesConfig,
          }}
        />
      );
    }
    return changedTableData;
  }, [data]);

  return (
    <div>
      <Typography.Title level={5}>Vertinimas</Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'evaluation',
            title: 'Vertinimo kriterijai',
            dataIndex: 'evaluation',
          },
        ]}
        dataSource={[tableData]}
        size="small"
      />
    </div>
  );
};
